import { useLayoutEffect, useRef, useState } from 'react';

export default function useMountedRef<T = HTMLDivElement>() {
  const ref = useRef<T>(null);
  const [, setMounted] = useState<boolean>(false);
  useLayoutEffect(() => {
    if (ref.current) {
      setMounted(true);
    }
  }, []);
  return ref;
}
